import * as React from 'react'
import type { Color } from '../../../theme/colors'
import colors from '../../../theme/colors'

type Props = {
  width?: number,
  height?: number,
  color?: Color
}

const Approve = ({ width, height, color, ...rest }: Props) => (
  <svg width={width} height={height} viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M17.5877 0.40514C17.4686 0.276765 17.327 0.17487 17.1709 0.105335C17.0148 0.0357999 16.8474 0 16.6783 0C16.5092 0 16.3418 0.0357999 16.1858 0.105335C16.0297 0.17487 15.888 0.276765 15.769 0.40514L6.22709 10.6227L2.21822 6.32202C2.0946 6.19432 1.94867 6.09391 1.78875 6.02651C1.62884 5.95912 1.45808 5.92607 1.28622 5.92925C1.11437 5.93243 0.944779 5.97178 0.787141 6.04504C0.629504 6.11831 0.486905 6.22407 0.367486 6.35627C0.248068 6.48847 0.154168 6.64453 0.0911484 6.81553C0.0281286 6.98654 -0.00277745 7.16915 0.000195856 7.35293C0.00316916 7.53671 0.0399634 7.71806 0.108477 7.88664C0.176991 8.05521 0.275883 8.2077 0.399506 8.33541L5.31773 13.5949C5.4368 13.7232 5.57845 13.8251 5.73453 13.8947C5.8906 13.9642 6.05801 14 6.22709 14C6.39617 14 6.56357 13.9642 6.71965 13.8947C6.87573 13.8251 7.01738 13.7232 7.13645 13.5949L17.5877 2.41852C17.7177 2.29027 17.8214 2.1346 17.8924 1.96134C17.9634 1.78808 18 1.60098 18 1.41183C18 1.22268 17.9634 1.03558 17.8924 0.86232C17.8214 0.68906 17.7177 0.533397 17.5877 0.40514Z"
      fill={color}
    />
  </svg>
)

Approve.defaultProps = {
  width: 18,
  height: 14,
  color: colors.Primary.GreyDark
}

export default Approve
